import { ReactElement, useState } from "react";
import styled from "styled-components";
import InternationalRegulations from "./InternationalRegulations";
import CapacitiesAndLimitations from "./CapacitiesAndLimitationsContainer";
import CredentialAccordianContainer from "./CredentialAccordianContainer";
import CredentialImageContainer from "./CredentialImageContainer";
import InnerAccordianSection from "components/InnerAccordianSection";
import { Credential } from "core/credentials/types";

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  flex-direction: column;
  width: 100%;
  padding-top: 24px;
`;

const Spacer = styled.div`
  height: 24px;
  width: 100%;
`;

interface Props {
  credential: Credential;
  isOpen?: boolean;
}

// function getCredentialsArray(candidate: CandidateDetails): Credential[] {
//   let credentials: Credential[] = [];
//   if (candidate.documents) {
//     credentials = [...credentials, ...candidate.documents];
//   }
//   if (candidate.certificates) {
//     credentials = [...credentials, ...candidate.certificates];
//   }
//   if (candidate.identifications) {
//     credentials = [...credentials, ...candidate.identifications];
//   }
//   return credentials;
// }

function checkHasVerifiedData(credential: Credential): boolean {
  const hasData =
    credential.domesticCapacityAndLimitationsSection ||
    credential.internationalCapacityAndLimitationsSection ||
    credential.internationalRegulationsSection;
  return Boolean(hasData);
}

function checkAnyCredentialsOpen(credential: Credential): boolean {
  const {
    domesticCapacityAndLimitationsSection,
    internationalCapacityAndLimitationsSection,
    internationalRegulationsSection,
  } = credential;
  if (
    domesticCapacityAndLimitationsSection &&
    domesticCapacityAndLimitationsSection.isOpen
  ) {
    return true;
  }
  if (
    internationalCapacityAndLimitationsSection &&
    internationalCapacityAndLimitationsSection.isOpen
  ) {
    return true;
  }
  if (
    internationalRegulationsSection &&
    internationalRegulationsSection.isOpen
  ) {
    return true;
  }
  return false;
}

export default function CredentialView({ credential }: Props): ReactElement {
  const isExpandable = checkHasVerifiedData(credential);
  const isOpen = checkAnyCredentialsOpen(credential);
  const [localIsOpen] = useState<boolean>(isOpen);

  return (
    <CredentialAccordianContainer
      expiration={credential.expirationDate}
      header={credential.title}
      isOpen={localIsOpen}
      isExpandable={isExpandable || Boolean(credential.imageUrl)}
    >
      <Container>
        <>
          <CredentialImageContainer
            imageUrl={credential.imageUrl ?? null}
            title={credential.title}
          />
          {/* Add spacer if there are more sections following */}
          {isExpandable && <Spacer />}
        </>
        {credential.internationalRegulationsSection !== undefined && (
          <>
            <InnerAccordianSection
              header="International Regulations"
              count={
                credential.internationalRegulationsSection.regulations
                  ?.length ?? 0
              }
              isOpen={credential.internationalRegulationsSection.isOpen}
            >
              <InternationalRegulations
                capAndLimitations={
                  credential.internationalRegulationsSection.regulations
                }
                searchTerm=""
              />
            </InnerAccordianSection>
            <Spacer />
          </>
        )}
        {credential.internationalCapacityAndLimitationsSection !==
          undefined && (
          <>
            <InnerAccordianSection
              header="International Capacities and Limitations"
              count={
                credential.internationalCapacityAndLimitationsSection
                  .capacitiesAndRegulations?.length ?? 0
              }
              isOpen={
                credential.internationalCapacityAndLimitationsSection.isOpen
              }
            >
              <CapacitiesAndLimitations
                capAndLimitations={
                  credential.internationalCapacityAndLimitationsSection
                    .capacitiesAndRegulations
                }
                searchTerm=""
              />
            </InnerAccordianSection>
            <Spacer />
          </>
        )}
        {credential.domesticCapacityAndLimitationsSection !== undefined && (
          <>
            <InnerAccordianSection
              header="Domestic Capacities and Limitations"
              count={
                credential.domesticCapacityAndLimitationsSection
                  .capacitiesAndRegulations?.length ?? 0
              }
              isOpen={credential.domesticCapacityAndLimitationsSection.isOpen}
            >
              <CapacitiesAndLimitations
                capAndLimitations={
                  credential.domesticCapacityAndLimitationsSection
                    .capacitiesAndRegulations
                }
                searchTerm=""
              />
            </InnerAccordianSection>
            <Spacer />
          </>
        )}
      </Container>
    </CredentialAccordianContainer>
  );
}
